// extracted by mini-css-extract-plugin
module.exports = {"listItem":"listItem__2D2z8","name":"name__WeZ92","badge":"badge__-OJVP","indent":"indent__2PL6Q"};